// extracted by mini-css-extract-plugin
module.exports = {"section":"TableContent_section__K1w2q","table":"TableContent_table__ptrQu"};